const isSafeFileName = function (filename) {
  if (!filename || typeof filename !== 'string') {
    return ''
  }
  // eslint-disable-next-line no-useless-escape
  const fileNameRegex = /[\,\!\|\~\`\#\$\%\^\&\*\{\}\:\;\"\<\>\?\？\+\s]/g
  const mathResult = filename.match(fileNameRegex)
  return mathResult === null ? '' : [...new Set(mathResult)].map(item => {
    return item === ' ' ? '空格' : item
  }).join(' ')
}

export default isSafeFileName



// WEBPACK FOOTER //
// ./src/model/fileValitor.js